import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// import { Spinner } from '@/components/Elements';
import { MainLayout } from '@/components/Layout';
import { lazyImport } from '@/utils/lazyImport';

const { Landing } = lazyImport(() => import('@/features/landing'), 'Landing');
const { Staff } = lazyImport(() => import('@/features/staff'), 'Staff');
const { News } = lazyImport(() => import('@/features/news'), 'News');
const { Story } = lazyImport(() => import('@/features/story'), 'Story');
const { CharacterRoutes } = lazyImport(() => import('@/features/character'), 'CharacterRoutes');
const { Book } = lazyImport(() => import('@/features/book'), 'Book');
const { Movie } = lazyImport(() => import('@/features/movie'), 'Movie');
const { Goods } = lazyImport(() => import('@/features/goods'), 'Goods');

const App = () => {
  return (
    <MainLayout>
      <Suspense fallback={<div className="h-full w-full">{/* <Spinner size="xl" /> */}</div>}>
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const aprilRoutes = [
  {
    path: '/april',
    element: <App />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '*', element: <Navigate to="." /> },
      { path: '/news', element: <News /> },
      { path: '/story', element: <Story /> },
      { path: '/character/*', element: <CharacterRoutes /> },
      { path: '/staff', element: <Staff /> },
      { path: '/book', element: <Book /> },
      { path: '/movie', element: <Movie /> },
      { path: '/goods', element: <Goods /> },
    ],
  },
];
